<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Thời Khóa Biểu" :link="[{ text: 'Thời khóa biểu', href: '../time-table-config' }]" />
      </div>
      <div>
        <v-btn depressed dark color="#0D47A1" @click.stop="() => $refs['popup-new-class-time-table'].openDialog()">
          <v-icon left>add</v-icon>Xếp thời khóa biểu
        </v-btn>
      </div>
    </div>
    <div class="mx-4">
      <v-tabs v-model="tab" active-class="tab-active" background-color="transparent">
        <v-tab v-for="item in getTabs" :key="item" class="tab-default">
          {{ item }}
        </v-tab>
      </v-tabs>
      <v-card class="elevation-0" outlined>
        <div :flat="$vuetify.breakpoint.smAndDown">
          <v-tabs-items v-model="tab">
            <v-tab-item :key="1">
              <ClassTimeTable />
            </v-tab-item>
            <v-tab-item :key="2">
              <TeacherTimeTable />
            </v-tab-item>
          </v-tabs-items></div
      ></v-card>
    </div>
    <PopupNewClassTimeTable ref="popup-new-class-time-table" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import get from 'lodash-es/get'
import TeacherTimeTable from './components/TeacherTimeTable.vue'
import ClassTimeTable from './components/ClassTimeTableForHD.vue'
import PopupNewClassTimeTable from './components/PopupNewClassTimeTable.vue'

export default {
  components: {
    Breadcrumbs,
    ClassTimeTable,
    TeacherTimeTable,
    PopupNewClassTimeTable,
  },
  data() {
    return {
      get,
      tab: null,
    }
  },
  computed: {
    getTabs() {
      return ['Lớp học', 'Giáo viên']
    },
  },
}
</script>

<style lang="scss" scoped></style>
